<div class="bar-graph"
id="{{idGraph}}"></div>